import { OrderSupportModalHeader } from '../../OrderSupportModalHeader'
import React, { FC, useCallback } from 'react'
import { Button, Heading, Modal, Text } from '@afterpaytouch/core'
import { useDisputeTranslation } from '../hooks'
import { useConsumerSizes } from '../../../utils/responsive'
import { DisputeCreationModalSteps, useDisputeCreationModalContext } from '../DisputeCreationModalContext'
import { TrackOnMount, useAmplitudeWithEnduringEventProperties } from '../../../integrations/amplitude'
import { TrackingEvent } from '../../../model/amplitude'

export const ContactMerchant: FC<{ reopenGetHelpModal: () => void }> = ({ reopenGetHelpModal }) => {
  const { textSize } = useConsumerSizes()
  const t = useDisputeTranslation()
  const { setStep, closeModal } = useDisputeCreationModalContext()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  const confirmHandler = useCallback(() => {
    setStep(DisputeCreationModalSteps.ContactMerchantInfo)
    logEvent(TrackingEvent.PRESSED_CREATE_DISPUTE_CONTACT_MERCHANT)
  }, [logEvent, setStep])
  const cancelHandler = useCallback(() => {
    closeModal()
    logEvent(TrackingEvent.PRESSED_CREATE_DISPUTE_CANCEL_CONTACT_MERCHANT)
  }, [closeModal, logEvent])
  const backToHelpModal = (): void => {
    closeModal()
    reopenGetHelpModal()
  }

  const heading = t('contactMerchant:head')
  const subtitle = t('contactMerchant:subtitle')
  const confirm = t('contactMerchant:confirm')
  const cancel = t('contactMerchant:cancel')

  return (
    <>
      <TrackOnMount eventName={TrackingEvent.VIEWED_CREATE_DISPUTE_CONTACT_MERCHANT} />
      <OrderSupportModalHeader onBack={backToHelpModal} onClose={cancelHandler}>
        <Heading size='L'>{heading}</Heading>
      </OrderSupportModalHeader>
      <Modal.Content>
        <div>
          <Text size={textSize} renderAs='span'>
            {subtitle}
          </Text>
        </div>
        <div className='mt-4'>
          <Button padding='Fluid' size='Large' onClick={confirmHandler}>
            {confirm}
          </Button>
        </div>
        <div className='mt-4'>
          <Button.Ghost padding='Fluid' size='Large' onClick={cancelHandler}>
            <div className='w-full'>{cancel} </div>
          </Button.Ghost>
        </div>
      </Modal.Content>
    </>
  )
}
